module.exports = __webpack_public_path__ + "static/media/DSC_0853.e7c00e39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0853.jpg
// module id = 673
// module chunks = 0